import { Component, Inject } from "@angular/core";

import {
  ALERT_MODAL_OPTIONS,
  AlertModalOptions
} from "@lantern/app/core/utils/modals/alert-modal-options";
import { ModalRef } from "@lantern/app/core/utils/modals/modal-ref";

import { ModalComponent } from "./modal.component";

@Component({
  template: `
    <div class="modal modal--confirm">
      <div class="modal__heading" *ngIf="options.title != null">
        {{ options.title }}
      </div>
      <div class="modal__body"><div [innerHTML]="options.message"></div></div>
      <div class="modal__footer">
        <button
          class="button button--primary button--spaced"
          type="button"
          (taInteract)="close(undefined)"
        >
          {{ options.confirmText }}
        </button>
      </div>
    </div>
  `
})
export class AlertModalComponent extends ModalComponent<void> {
  options: AlertModalOptions;

  constructor(
    modalRef: ModalRef<void>,
    @Inject(ALERT_MODAL_OPTIONS) options: any
  ) {
    super(modalRef);

    this.options = Object.assign(
      {
        confirmText: "OK"
      },
      options
    );
  }
}
